import {AbstractControl, FormControl, FormGroup, ValidationErrors, ValidatorFn, Validators} from "@angular/forms";


export function latinCharactersValidator(allowedPattern: RegExp): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const value = control.value;

    if (!value) {
      return null;
    }

    if (allowedPattern.test(value)) {
      return null;
    }


    for (let i = 0; i < value.length; i++) {
      const char = value.charAt(i);
      if (!allowedPattern.test(char)) {
        return {
          latinCharacters: {
            invalidChar: char,
            message: `Invalid character "${char}" found. Only Latin characters are allowed.`
          }
        };
      }
    }

    // Fallback
    return { latinCharacters: { message: 'Must use Latin characters only.' } };
  };
}

export function createPaymentForm(): FormGroup {

  return new FormGroup({
    bankName: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
    ]),
    bankAddress: new FormControl('', [
      Validators.required,
      Validators.maxLength(255),
      latinCharactersValidator(/^[A-Za-z0-9 .,'/\-]+$/)
    ]),
    accountHolderName: new FormControl('', [
      Validators.required,
      Validators.maxLength(255),
      latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
    ]),
    accountHolderAddress: new FormControl('', [
      Validators.required,
      Validators.maxLength(255),
      latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
    ]),
    iban: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
    ]),
    swift: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
    ]),
    aba: new FormControl('', [
      Validators.required,
      Validators.maxLength(100),
      latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
    ]),
    currencyId: new FormControl('', [Validators.required]),

    correspondBankName: new FormControl('', [
      Validators.maxLength(100),
      latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
    ]),
    correspondBankAddress: new FormControl('', [
      Validators.maxLength(255),
      latinCharactersValidator(/^[A-Za-z0-9 .,'/\-]+$/)
    ]),
    correspondIBAN: new FormControl('', [
      Validators.maxLength(100),
      latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
    ]),
    correspondSWIFT: new FormControl('', [
      Validators.maxLength(100),
      latinCharactersValidator(/^[A-Za-z0-9 .,'-]+$/)
    ]),
    correspondCurrencyId: new FormControl(null)
  });
}
